var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
export class D2CUserReservationForErpDto {
    constructor(initializer) {
        this.id = initializer.id;
        this.pickUpAt = initializer.pickUpAt;
        this.dropOffAt = initializer.dropOffAt;
        this.vehicleModelName = initializer.vehicleModelName;
        this.state = initializer.state;
        this.listPrice = initializer.listPrice;
        this.finalPrice = initializer.finalPrice;
        this.createdAt = initializer.createdAt;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], D2CUserReservationForErpDto.prototype, "pickUpAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], D2CUserReservationForErpDto.prototype, "dropOffAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], D2CUserReservationForErpDto.prototype, "createdAt", void 0);
